<template>
    <div>
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="1" tab="按项目"><Article></Article></a-tab-pane>
        <a-tab-pane key="2" tab="按行业" force-render><Inquiry></Inquiry></a-tab-pane>
      </a-tabs>
    </div>
</template>

<script>
    import API from "./api";
    import Inquiry from './Inquiry/index'
    import Article from './article/index'
    export default {
        name: "index",
        data() {
            return {activeKey:'1'
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/ProductArticle"; //设置左侧导航2-2 active
        },
      components:{Inquiry,Article},
        mounted() {

        },
        computed: {

        },
        methods: {
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }

    .inputs {
        display: inline-block;
        width: 70px
    }
    .num_input{width:30%}
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
</style>
